import { UserProfileInline } from "app/components/UserProfileInline";
import { Link, useParams } from "react-router-dom";
import { useMemo } from "react";
import BookListItem from "app/books/components/BookListItem";

export const DebateTopicListItem = ({ topic }) => {
  const { school } = useParams();

  const renderList = useMemo(() => {
    const keywordArray = topic.keyword.split(", ");
    return keywordArray.map((keyword, idx) => {
      return <li key={idx}>#{keyword}</li>;
    });
  }, [topic]);

  return (
    <li className="grid-row p-tb-7 bd-b-gray">
      <div className="col-3 col-md-12">
        <Link to={`/${school}/book/${topic.book.isbn}`}>
          <BookListItem book={topic.book} />
        </Link>
      </div>
      <div className="col-9 col-md-12">
        <div className="topic p-tb-1 p-lr-4 bg-white box-shadow round">
          <div className="header p-tb-2 bd-b-light-gray">
            <UserProfileInline
              id={topic.user?.id}
              name={topic.user?.name || topic.user_name}
              type={topic.user?.type}
              school={topic.user?.schoolName || topic?.schoolName}
              image={topic.user?.image}
            />
            <Link
              to={`/${school}/book/${topic.book.isbn}/debate`}
              className="btn-md main-color"
            >
              토론 바로가기
            </Link>
          </div>
          <div className="content m-tb-3 p-tb-4 p-lr-8 bg-light-gray round fs-18">
            <div className="p-tb-1">{topic.debateContent}</div>
            <ul className="keyword-list p-tb-1">{renderList}</ul>
          </div>
          <p className="p-b-2 fs-15">
            <i className="fa-regular fa-comments fc-light-gray p-r-1"></i>총{" "}
            <span className="fc-main-color">
              <strong>{topic.debateGcount}</strong>
            </span>
            개의 댓글이 달렸어요.
          </p>
        </div>
      </div>
    </li>
  );
};
